export const LOADING = "LOADING";
export const USERS = "USERS";
export const USER_PERMISSION = "USER_PERMISSION";
export const CURRENT_USER_PERMISSION = "CURRENT_USER_PERMISSION";
